<template>
  <div v-if="product">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>材料管理</el-breadcrumb-item>
      <el-breadcrumb-item>出库单</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel">
      <el-page-header @back="$router.go(-1)" content="出库单详情">
      </el-page-header>
      <el-descriptions border title="" size="small" class="m-b-10">
        <el-descriptions-item label="出库单号">{{
          product.number
        }}</el-descriptions-item>
        <el-descriptions-item label="出库日期">
          {{ product.confirm_time || '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="钻头">
          <span v-for="(no, index) in product.drills" :key="no">
            {{ index > 0 ? ' 、' : '' }}<DrillLink :no="no"></DrillLink>
          </span>
        </el-descriptions-item>
        <el-descriptions-item label="仓库">
          {{ product.stockroom.name }}
        </el-descriptions-item>
        <el-descriptions-item label="出库类型">
          {{ ItemStockOutCategoryMap[product.category] }}
        </el-descriptions-item>
        <el-descriptions-item label="部门">
          {{ product.department }}
        </el-descriptions-item>
        <el-descriptions-item label="创建时间">{{
          $time(product.created_at).format('YYYY-MM-DD HH:mm')
        }}</el-descriptions-item>
        <el-descriptions-item label="状态">
          <el-tag size="mini" type="primary">{{
            OutboundOrderStatusMap[product.status]
          }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="记账人">
          {{ product.bookkeeper }}
        </el-descriptions-item>
        <el-descriptions-item label="备注">
          {{ product.remark }}
        </el-descriptions-item>
      </el-descriptions>
      <el-button
        v-code="51301"
        type="primary"
        size="mini"
        class="mr-10"
        plain
        @click="editProduct"
        v-if="admin && product.status == 1"
        >编辑</el-button
      >
      <el-popconfirm
        v-code="51301"
        title="确定完成出库吗？"
        @confirm="handleConfirm({}, -1)"
        v-if="admin && product.status == 1"
      >
        <el-button
          slot="reference"
          type="primary"
          size="mini"
          class="mr-10"
          plain
          >确认出库</el-button
        >
      </el-popconfirm>
      <el-button
        v-if="admin"
        v-code="51301"
        type="primary"
        size="mini"
        plain
        @click="printOrder"
        >打印</el-button
      >
    </div>

    <div class="panel">
      <el-tabs v-model="activeTab">
        <el-tab-pane label="材料明细" name="tab1">
          <el-table
            border
            :data="product.items"
            :key="randomKey"
            @cell-click="editData"
            ref="table"
          >
            <el-table-column
              label="材料分类"
              prop="commodity_category"
              align="center"
              min-width="100"
            >
              <template slot-scope="scope">
                <CommodityCategorySelect
                  v-if="scope.row[scope.column.property + 'isShow']"
                  :ref="scope.column.property"
                  v-model="scope.row.commodity_category"
                  @blur="handleSaveItem(scope.row, scope.column, scope.$index)"
                ></CommodityCategorySelect>
                <span v-else>{{
                  CommodityCategoryMap.filter(
                    (item) => item.id == scope.row.commodity_category
                  )[0].name
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="材料编码"
              prop="item_id"
              align="center"
              min-width="100"
            >
              <template slot-scope="scope">
                <ItemSelect
                  v-if="scope.row[scope.column.property + 'isShow']"
                  :ref="scope.column.property"
                  :category="scope.row.commodity_category"
                  v-model="scope.row.item_id"
                  @blur="handleSaveItem(scope.row, scope.column, scope.$index)"
                ></ItemSelect>
                <span v-else>{{ scope.row.item.code }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="名称"
              prop="name"
              align="center"
              min-width="100"
            >
              <template slot-scope="scope">
                <span class="text-muted">{{ scope.row.item.name }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="规格"
              prop="specification"
              align="center"
              min-width="100"
            >
              <template slot-scope="scope">
                <span class="text-muted">{{
                  scope.row.item.specification
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="型号或倒角"
              prop="model_number"
              align="center"
              min-width="100"
            >
              <template slot-scope="scope">
                <span class="text-muted">{{
                  scope.row.item.model_number
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="计量单位"
              prop="unit"
              align="center"
              min-width="100"
            >
              <template slot-scope="scope">
                <span class="text-muted">{{ scope.row.item.unit }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="数量"
              prop="number"
              align="center"
              min-width="100"
              v-if="product.belong_month != 2"
            >
              <template slot-scope="scope">
                <el-input-number
                  :controls="false"
                  v-if="scope.row[scope.column.property + 'isShow']"
                  :ref="scope.column.property"
                  v-model.number="scope.row.number"
                  @blur="handleSaveItem(scope.row, scope.column, scope.$index)"
                ></el-input-number>
                <span v-else>{{ scope.row.number }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="金额"
              prop="item_price"
              align="center"
              min-width="100"
              v-else
            >
              <template slot-scope="scope">
                <el-input-number
                  :precision="2"
                  v-if="scope.row[scope.column.property + 'isShow']"
                  :ref="scope.column.property"
                  v-model.number="scope.row.item_price"
                  @blur="handleSaveItem(scope.row, scope.column, scope.$index)"
                  :controls="false"
                ></el-input-number>
                <span v-else>{{ scope.row.item_price.toFixed(2) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" v-if="admin">
              <template slot-scope="scope">
                <el-popconfirm
                  v-if="canEdit"
                  v-code="51301"
                  title="确定删除该材料吗？"
                  @confirm="handleItemDelete(scope.row, scope.$index)"
                >
                  <el-link
                    slot="reference"
                    type="danger"
                    class="font-12"
                    :underline="false"
                    >删除</el-link
                  >
                </el-popconfirm>
                <el-popconfirm
                  v-if="product.status == 2 && scope.row.status == 1"
                  v-code="51301"
                  title="确认更新此出库单材料明细吗？"
                  @confirm="handleConfirm(scope.row, scope.$index)"
                >
                  <el-link
                    slot="reference"
                    type="primary"
                    class="font-12 ml-5"
                    :underline="false"
                    >确认</el-link
                  >
                </el-popconfirm>
              </template>
            </el-table-column>
          </el-table>
          <el-button
            v-if="admin && canEdit"
            v-code="51301"
            type="primary"
            class="mt-10"
            size="mini"
            @click="handleAddItem"
            >添加材料</el-button
          >
        </el-tab-pane>
      </el-tabs>
    </div>
    <EditFormer
      :model="model"
      :show.sync="formerVisible"
      @callback="updatedCallback"
    ></EditFormer>
    <OrderPrint :order="product" ref="print" :key="randomKey"></OrderPrint>
  </div>
</template>

<script>
import {
  outboundOrderDetail,
  itemOutRecordUpdate,
  itemOutRecordDelete,
  outboundOrderConfirm,
} from '@/service/getData'
import EditFormer from './editor'
import { getStore } from '@/config/mUtils'

import {
  CommodityCategoryMap,
  OutboundOrderStatusMap,
  PurchaseOrderLogMap,
  ItemStockOutCategoryMap,
} from '@/config/global'
import CommodityCategorySelect from '@/components/select/commodity_category.vue'
import ItemSelect from './ItemSlect.vue'
import OrderPrint from './OrderPrint.vue'

import Vue from 'vue'
import Print from '@/plugins/jquery.PrintArea.js'
import { itemOutRecordNew } from '../../../../service/getData'
Vue.use(Print)

export default {
  components: {
    EditFormer,
    CommodityCategorySelect,
    ItemSelect,
    OrderPrint,
  },
  data() {
    return {
      admin: getStore('userInfo').is_stockroom_admin,
      ItemStockOutCategoryMap,
      CommodityCategoryMap,
      OutboundOrderStatusMap,
      PurchaseOrderLogMap,
      activeTab: 'tab1',
      product: null,
      formerVisible: false,
      model: {},
      randomKey: Math.random(),
    }
  },
  computed: {
    canEdit() {
      return (
        this.product &&
        (!this.product.confirm_time ||
          this.$time(this.product.confirm_time).format('YYYY-MM') ==
            this.$time(new Date()).format('YYYY-MM'))
      )
    },
  },
  created() {
    this.getData()
  },
  methods: {
    printOrder() {
      this.$print(this.$refs.print)
    },

    async getData() {
      let res = await outboundOrderDetail(this.$route.params.id)
      if (res.status == 0) {
        this.product = res.data
        this.product.drills = this.product.drill_serial_numbers
          ? this.product.drill_serial_numbers.split(',')
          : []
        this.product.created = true
      }
    },
    editProduct() {
      this.model = this.clone(this.product)
      this.formerVisible = true
    },
    updatedCallback() {
      this.getData()
    },
    handleAddItem() {
      this.product.items.push({
        outbound_order_id: this.product.id,
        commodity_category: '',
        commodity_categoryisShow: true,
        item_id: '',
        number: 0,
        item_price: 0,
        item: {},
      })
      this.$nextTick(() => {
        this.$refs['commodity_category'].$refs.itemSelect.focus()
      })
    },
    editData(row, column) {
      if (
        !this.admin ||
        !column.property ||
        row[column.property + 'isShow'] ||
        row.status == 0
      ) {
        return
      }

      if (
        this.product.items.filter(
          (item) => item.commodity_categoryisShow || item.item_idisShow
        ).length > 0
      ) {
        return
      }

      if (column.property == 'item_id' && row.item_id == 0) {
        row.item_id = ''
      }
      row[column.property + 'isShow'] = true
      this.refreshTable()
      this.$nextTick(() => {
        if (['commodity_category', 'item_id'].includes(column.property)) {
          this.$refs[column.property].$refs.itemSelect.focus()
        } else {
          this.$refs[column.property] && this.$refs[column.property].focus()
        }
      })
    },
    refreshTable() {
      this.randomKey = Math.random()
    },
    async handleSaveItem(row, column, index) {
      if (column.property == 'commodity_category' && !row.commodity_category) {
        this.product.items.splice(index, 1)
        return
      }
      row.item_id = row.item_id || 0
      let res
      if (row.id) {
        res = await itemOutRecordUpdate(row)
      } else {
        res = await itemOutRecordNew(row)
      }
      if (res.code == 0) {
        this.product.items[index] = res.data
      } else {
        this.getData()
      }
      row[column.property + 'isShow'] = false
      this.refreshTable()
    },
    async handleConfirm(row, index) {
      let res = await outboundOrderConfirm({
        id: this.product.id,
        record_id: row.id || 0,
      })
      if (res.code == 0) {
        this.$message.success('操作成功！')
        this.getData()
      }
    },
    async handleItemDelete(item, index) {
      let res = await itemOutRecordDelete(item.id)
      if (res.code == 0) {
        this.product.items.splice(index, 1)
      }
    },

    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }

        if (
          ['total_tax', 'total_no_tax_price', 'total_price'].includes(
            column.property
          )
        ) {
          const values = data.map((item) => Number(item[column.property]))
          if (!values.every((value) => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + curr
              } else {
                return prev
              }
            }, 0)

            sums[index] = sums[index].toFixed(2)
          } else {
            sums[index] = ''
          }
        }
      })

      return sums
    },
  },
}
</script>

<style scoped>
.title {
  font-size: 16px;
  font-weight: 400;
  display: flex;
  justify-content: space-between;
  margin-top: 40px;
}

.el-table__cell .el-input-number {
  width: 100%;
}
/deep/.el-table__cell .el-input-number .el-input__inner {
  padding: 0 !important;
}
</style>